import { getSortedCalendars } from '@/services/connectedCalendars.service';
import IHost from '@/types/IHost';
import { Accordion, FormLabel } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import Host from './components/Host/Host';
import Calendar from './components/Host/components/Calendar';

interface IConnectedCalendarListProps {
	hosts: IHost[];
	isLoading: boolean;
	showSecondaryCalendars: boolean;
	onChangeRead: (calendarId: string, value: boolean) => void;
	onChangeWrite: (calendarId: string, value: boolean) => void;
}

export default function ConnectedCalendarList(props: IConnectedCalendarListProps) {
	const { t } = useTranslation();

	if (props.hosts.length > 1) {
		return (
			<>
				<FormLabel>{t('Collaborators who have connected calendars')}</FormLabel>
				<Accordion allowToggle defaultIndex={0} p="0">
					{props.hosts.map((host) => (
						<Host
							avatar={host.avatar}
							calendars={host.calendars}
							email={host.email}
							isLoading={props.isLoading}
							key={host.id}
							onChangeRead={props.onChangeRead}
							onChangeWrite={props.onChangeWrite}
							showSecondaryCalendars={props.showSecondaryCalendars}
						/>
					))}
				</Accordion>
			</>
		);
	}

	return (
		<Accordion allowToggle defaultIndex={0} p="0">
			{getSortedCalendars(props.hosts[0].calendars)
				.filter((c) => c.primary || props.showSecondaryCalendars)
				.map((c, i) => (
					<Calendar
						{...c}
						isOpen={i === 0}
						isLoading={props.isLoading}
						isReadOnly={c.readOnly}
						key={c.id}
						onChangeRead={props.onChangeRead}
						onChangeWrite={props.onChangeWrite}
					/>
				))}
		</Accordion>
	);
}
